import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
export const AsyncSavedDashboardFiltersPanel = Loadable({
  loader: () => import('./SavedDashboardFiltersPanel').then(module => module.SavedDashboardFiltersPanel),
  LoadingComponent: () => /*#__PURE__*/_jsx(UILoadingOverlay, {
    layout: "centered"
  })
});